module.exports = __webpack_public_path__ + "img/cover_img.6b2d3b98.png";